// Utility for CZK formatting
export const formatCZK = (value) => (value ? value.toLocaleString('cs-CZ', { style: 'currency', currency: 'CZK', maximumFractionDigits: 0 }) : 'Na dotaz')

// Color for price/m² (green=good, red=expensive)
export const getPriceColor = (value, min, max) => {
  if (max === min) return '#888'
  const percent = (value - min) / (max - min)
  const r = Math.round(255 * percent)
  const g = Math.round(180 * (1 - percent))
  return `rgb(${r},${g},120)`
}

// Progress bar component
export const ProgressBar = ({ value, max, color = 'bg-blue-500' }) => (
  <div className="w-full bg-gray-200 rounded-full h-2">
    <div className={`${color} h-2 rounded-full transition-all duration-300`} style={{ width: `${Math.min((value / max) * 100, 100)}%` }} />
  </div>
)
